import {
  SearchAutocomplete,
  SearchAutocompleteOption,
} from '@/components/inputs'
import { PLACE_TYPE_OPTIONS } from '@/components/forms/ObservationLogFormContainer/fieldsOptions'

type PlaceTypesSelectProps = {
  value?: string
  onChange: (value: string | undefined) => void
  placeholder?: string
}

export const PlaceTypesSelect = ({
  value,
  onChange,
  placeholder,
}: PlaceTypesSelectProps): JSX.Element => (
  <SearchAutocomplete
    value={value}
    onChange={onChange}
    options={PLACE_TYPE_OPTIONS.map(
      ({ value, name }) =>
        ({
          label: name,
          value,
        } as SearchAutocompleteOption)
    )}
    placeholder={placeholder}
    sort={true}
    fieldSx={{ width: 280 }}
  />
)
